/**
 * Promise-basierter Bestätigungs-Dialog (Jul-2026, Bugfix).
 *
 * Ersetzt window.confirm(), das in installierten PWAs / manchen mobilen
 * Browsern stillschweigend "false" liefert — Buttons wirkten dann "tot"
 * (z. B. Abrechnen/Stornieren im Werkstattauftrag).
 *
 * Nutzung:  const ok = await confirmDialog("Wirklich stornieren?");
 * Voraussetzung: <ConfirmDialogHost /> ist einmal in App.js gemountet.
 */
import { useEffect, useState } from "react";
import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
    AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../components/ui/alert-dialog";

let _resolver = null;
let _setState = null;

export function confirmDialog(message, opts = {}) {
    const { title = "Bitte bestätigen", confirmLabel = "Ja, fortfahren", cancelLabel = "Abbrechen" } = opts;
    return new Promise((resolve) => {
        if (!_setState) { resolve(window.confirm(message)); return; }
        _resolver = resolve;
        _setState({ open: true, message, title, confirmLabel, cancelLabel });
    });
}

export function ConfirmDialogHost() {
    const [state, setState] = useState({ open: false, message: "", title: "", confirmLabel: "", cancelLabel: "" });
    useEffect(() => {
        _setState = setState;
        return () => { _setState = null; };
    }, []);
    const close = (val) => {
        setState((s) => ({ ...s, open: false }));
        if (_resolver) { _resolver(val); _resolver = null; }
    };
    return (
        <AlertDialog open={state.open} onOpenChange={(o) => { if (!o) close(false); }}>
            <AlertDialogContent data-testid="confirm-dialog">
                <AlertDialogHeader>
                    <AlertDialogTitle>{state.title}</AlertDialogTitle>
                    <AlertDialogDescription className="whitespace-pre-line">{state.message}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={() => close(false)} data-testid="confirm-dialog-cancel">{state.cancelLabel}</AlertDialogCancel>
                    <AlertDialogAction onClick={() => close(true)} data-testid="confirm-dialog-ok">{state.confirmLabel}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
